import { Buffer } from "buffer";

function useURLTokenDecode() {
    // Javascript equivalent to HttpServerUtility.UrlTokenDecode in .NET
    // The metadata_storage_path field is encoded with padding, so a simple base64 decoding
    // will not work. Refer to official documentation for more details: https://docs.microsoft.com/en-us/azure/search/search-indexer-field-mappings

    const URLTokenDecode = (token) => {
	if (token.length === 0) return "";

	// The last character in the token is the number of padding characters.
	var numberOfPaddingCharacters = token.slice(-1);

	// The Base64 string is the token without the last character.
	token = token.slice(0, -1);

	// '-'s are '+'s and '_'s are '/'s.
	token = token.replace(/-/g, "+");
	token = token.replace(/_/g, "/");

	// Pad the Base64 string out with '='s
	for (var i = 0; i < numberOfPaddingCharacters; i++) token += "=";

	return Buffer.from(token, "base64").toString();
  };

  return {
    URLTokenDecode
  };
}

export { useURLTokenDecode };

